import UserDataService from 'src/modules/userData/userDataService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/store';
import { i18n } from 'src/i18n';

const prefix = 'USERDATA_FORM';

const userDataFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: userDataFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await UserDataService.find(id);
      }

      dispatch({
        type: userDataFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: userDataFormActions.INIT_ERROR,
      });

      getHistory().push('/user-data');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: userDataFormActions.CREATE_STARTED,
      });

      await UserDataService.create(values);

      dispatch({
        type: userDataFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.userData.create.success'),
      );

      getHistory().push('/user-data');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: userDataFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: userDataFormActions.UPDATE_STARTED,
      });

      await UserDataService.update(id, values);

      dispatch({
        type: userDataFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.userData.update.success'),
      );

      getHistory().push('/user-data');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: userDataFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default userDataFormActions;
